export default {"src":"/_next/static/media/arrow-right.c1aeec41.svg","height":19,"width":28};